"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as a, Fragment as s, jsxs as u } from "react/jsx-runtime";
import * as t from "react";
const i = /*#__PURE__*/ t.createContext({
    mounted: !1,
    dialog: null,
    setDialog: ()=>{}
}), g = /*#__PURE__*/ t.lazy(()=>import(/* webpackChunkName: "dialog" */ "./dialog.js")), c = ()=>{
    throw Error("Tried to show a dialog but the DialogRoot component was not mounted (missing ThemeContextProvider?)");
}, m = ()=>{
    const { dialog: r, setDialog: l, mounted: n } = t.useContext(i), e = t.useCallback((o)=>{
        if (n || c(), o && r) throw Error("Tried to show a dialog on top of another dialog");
        l(o);
    }, [
        l,
        r,
        n
    ]);
    return t.useMemo(()=>({
            alert: (o)=>e(_object_spread({
                    type: "alert"
                }, o)),
            confirm: (o)=>e(_object_spread({
                    type: "confirm"
                }, o)),
            dialog: (o)=>e(_object_spread({
                    type: "dialog"
                }, o))
        }), [
        e
    ]);
}, D = (param)=>{
    let { children: r } = param;
    const { mounted: l } = t.useContext(i), [n, e] = t.useState(null), o = t.useMemo(()=>({
            mounted: !0,
            dialog: n,
            setDialog: e
        }), [
        n,
        e
    ]);
    return l ? /* @__PURE__ */ a(s, {
        children: r
    }) : /* @__PURE__ */ u(i.Provider, {
        value: o,
        children: [
            r,
            n && /* @__PURE__ */ a(t.Suspense, {
                fallback: null,
                children: /* @__PURE__ */ a(g, _object_spread_props(_object_spread({}, n), {
                    onDestroy: ()=>{
                        e(null);
                    }
                }))
            })
        ]
    });
};
export { D as DialogRoot, m as useDialog };
